import Form from "../modules/form";

const Collaboration = {
  init() {
    $("form.cform").each(function () {
      new Form($(this)[0]);
    });
  },
};

export default Collaboration;
